import { createMutation } from '@tanstack/svelte-query';
import { createDinModule, deleteDinModule, updateDinModule } from '$lib/api/din_module';
import { invalidateAfterDinModuleCreate } from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { CreateDinModuleRequest, DinModuleRequest, DinModuleResponse } from '$lib/types/din_module';

export const createDinModuleMutation = (
	rcuScope: ScopeFn,
	unitScope: ScopeFn = getUnitScope()
) =>
	createMutation<DinModuleResponse, Error, CreateDinModuleRequest>(() => ({
		mutationFn: (request) => createDinModule(request),
		onSuccess: () =>
			invalidateAfterDinModuleCreate(resolveScope(unitScope), resolveScope(rcuScope))
	}));

export const updateDinModuleMutation = (
	rcuScope: ScopeFn,
	unitScope: ScopeFn = getUnitScope()
) =>
	createMutation<DinModuleResponse, Error, { id: number; request: DinModuleRequest }>(() => ({
		mutationFn: ({ id, request }) => updateDinModule(id, request),
		onSuccess: () =>
			invalidateAfterDinModuleCreate(resolveScope(unitScope), resolveScope(rcuScope))
	}));

export const deleteDinModuleMutation = (
	rcuScope: ScopeFn,
	unitScope: ScopeFn = getUnitScope()
) =>
	createMutation<void, Error, number>(() => ({
		mutationFn: (id) => deleteDinModule(id),
		onSuccess: () =>
			invalidateAfterDinModuleCreate(resolveScope(unitScope), resolveScope(rcuScope))
	}));
